import React, { useState, useEffect, useRef } from 'react';
import useAPI from '../../hooks/useAPI';
import Header from '../layout/Header';
import Spinner from '../plugins/Spinner';
import { useForm } from 'react-hook-form';
import { BsUmbrella } from 'react-icons/bs';
import styled from 'styled-components';
import Picker from 'emoji-picker-react';
import { sendToast } from '../plugins/toastAll';
import Select from 'react-select';
import ReactPlayer from 'react-player';
import { upload_s3 } from './UploaderS3';

import { FaRegFaceLaugh } from 'react-icons/fa6';
import { IoClose } from 'react-icons/io5';
import { ToastContainer } from 'react-toastify';
import {
  BsTrash3,
  BsFillInfoCircleFill,
  BsFillTelephoneFill,
} from 'react-icons/bs';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { TiExport } from 'react-icons/ti';
import { Toaster } from 'react-hot-toast';

const CloseMessage = () => {
  const [companie, setCompanie] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState(false);

  const [messageCheck, setMessageCheck] = useState(false);
  const [typeMessage, setTypeMessage] = useState('basic');
  const [bodyMessage, setBodyMessage] = useState('');
  const [interactiveOptions, setInteractiveOptions] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [templateSelected, setTemplateSelected] = useState(null);
  const [closeEmojis2, setCloseEmojis2] = useState(false);
  const [showPicker2, setShowPicker2] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [errorOptions, setErrorOptions] = useState(false);
  const [errorCampaign, setErrorCampaign] = useState(false);

  const [correspondence, setCorrespondence] = useState([]);
  const [date, setDate] = useState('');
  const [body, setBody] = useState('');
  const [templateWhatsapp, setTemplateWhatsapp] = useState(false);
  const [templateSms, setTemplateSms] = useState(true);
  const [templateHeader, setTemplateHeader] = useState(false);
  const [contentHeader, setContentHeader] = useState('');
  const [contentTextHeader, setContentTextHeader] = useState('');
  const [listButtonsCallToAction, setListButtonsCallToAction] = useState([]);
  const [listButtonsQuickReply, setListButtonsQuickReply] = useState([]);
  const [listButtonsUrlDynamic, setListButtonsUrlDynamic] = useState([]);
  const [numberParams, setNumberParams] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState('');
  const [selectedVideo, setSelectedVideo] = useState('');
  const [selectedImage, setSelectedImage] = useState('');
  const [isUrlDynamic, setIsUrlDynamic] = useState('');
  const [isUrlDynamic2, setIsUrlDynamic2] = useState('');
  const [errorMedia, setErrorMedia] = useState(false);
  const [sizeMax, setSizeMax] = useState(false);
  const [documentt, setDocumentt] = useState('');
  const [fileType, setFileType] = useState(null);

  const { urlAPI_1, urlAPI_2, fetchWithAuth } = useAPI();

  const urlFile = useRef("");
  const nameFile = useRef("");
  const sizeFile = useRef("");
  const templateIdRef = useRef("");

  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    reset,
    unregister,
  } = useForm({});

  useEffect(() => {
    getCompanie();
  }, []);

  const getCompanie = async () => {
    const resultIdCompany = localStorage.getItem('ID_COMPANY');
    try {
      setLoading(true);
      const url = urlAPI_2 + 'companies/' + resultIdCompany;
      const options = { method: 'GET', mode: 'cors' };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      if (result.code === 0) {
        sendToast(result);
      } else if (!result.data) {
        setValidation(true);
        setCompanie([]);
      } else {
        setCompanie(result.data[0]);
        setValidation(false);

        const { closedMessage } = result.data[0];

        setMessageCheck(closedMessage?.status);
        setBodyMessage(closedMessage?.message?.body);
        setTypeMessage(closedMessage?.type);

        if (
          closedMessage?.type == 'interactive' &&
          closedMessage?.message?.options?.length
        ) {
          setInteractiveOptions(closedMessage?.message?.options);
        }

        if (
          closedMessage?.type == 'campaign' &&
          closedMessage?.message?.template
        ) {
          handleChange(closedMessage?.message?.template?.template[0]);
          const filterBody = closedMessage?.message?.template?.template[0]?.content?.filter((tem) => {
            if (tem.type === 'BODY') return tem;
          });
          const bod = filterBody[0]?.text;
          closedMessage?.message?.template?.numberParams?.forEach((value, index) => {
            setNumberParams((prevParams) => {
              const updatedParams = [...prevParams];
              updatedParams[index] = value;

              const updatedBody = updatedParams.reduce((bod, param, k) => {
                var field = '';
                if (param === 'email') {
                  field = 'Correo usuario';
                } else if (param === 'name') {
                  field = 'Nombre usuario';
                } else if (param === 'phone') {
                  field = 'Teléfono usuario';
                } else if (param.includes('{{')) {
                  field = param;
                } else {
                  field = `${param} usuario`;
                }
                const placeholder = `{{${k + 1}}}`;
                return bod.replaceAll(placeholder, field);
              }, bod);
              
              setBody(updatedBody);
              return updatedParams;
            });
          });
        }

        reset(
          {
            messageCheck: closedMessage?.status,
            message: closedMessage?.message?.body,
            typeMessage: closedMessage?.type,
          },
          { keepDefaultValues: true }
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const putCompany = async (values) => {
    const {urlParam,urlParam2} = watch();

    let data = {
      closedMessage: {
        status: messageCheck,
        type: values.typeMessage,
        message: {},
      },
    };

    if (values.typeMessage == 'basic') {
      data.closedMessage.message['body'] = values.bodyMessage;
    }

    if (values.typeMessage == 'interactive') {
      if (!interactiveOptions.length) {
        setErrorOptions(true);
        return;
      }

      let interactive = {};
      if (interactiveOptions.length > 3) {
				interactive = {
					type: "list",
					body: {
						text: values.bodyMessage,
					},
					action: {
						button: "Seleccionar",
						sections: [
							{
								title: "Seleccionar",
								rows: interactiveOptions.map((option) => {
									return {
										id: option.id,
										title: option.label
									};
								}),
							},
						],
					},
				};
			} else {
				interactive = {
					type: "button",
					body: {
						text: values.bodyMessage,
					},
					action: {
						buttons: interactiveOptions.map((option) => {
							return {
								type: "reply",
								reply: {
									id: option.id,
                  title: option.label
								},
							};
						}),
					},
				};
			}

      data.closedMessage.message['body'] = values.bodyMessage;
      data.closedMessage.message['options'] = interactiveOptions;
      data.closedMessage.message['interactive'] = interactive;
    }

    if (values.typeMessage == 'campaign') {
      if (!templateSelected?.length) {
        setErrorCampaign(true);
        return;
      }

      let arrFields = [];

      const filterBody = templateSelected[0].content.filter(tem => {if (tem.type === "BODY") return tem})
      if(filterBody.length){
        const textMedio = filterBody[0].text;
        arrFields = textMedio.match(/{{\d+}}/g) || [];
      }

      let objParamsBody = [];
      if (arrFields) {
        for (let i = 0; i < arrFields.length; i++) {
          objParamsBody.push({type: "text", text: numberParams[i], number: arrFields[i]})
        }
      }

      let objParamsMedia = {};
      if(fileType == "image" || fileType == "video" || fileType == "document"){
        let data_media = {urlFile: urlFile.current, nameFile: nameFile.current, sizeFile: sizeFile.current};
        if (fileType == "image") {
          objParamsMedia = { image: data_media };
        } else if (fileType == "video") {
          objParamsMedia = { video: data_media };
        } else if (fileType == "document") {
          objParamsMedia = {
            document: data_media,
          };
        }
      }

      let varUrl = "";
      if (isUrlDynamic) {
        varUrl = urlParam;
      } else if (isUrlDynamic2) {
        varUrl = urlParam2;
      }

      data.closedMessage.message['template'] = {
        templateId: templateSelected[0].id,
        parametersMedia: objParamsMedia,
        parametersBody: objParamsBody,
        parameterUrl: varUrl,
        template: templateSelected,
        numberParams: numberParams,
      };
    }

    const id = companie._id;
    try {
      setLoading(true);
      const url = urlAPI_2 + 'companies/' + id;
      const options = {
        method: 'PUT',
        mode: 'cors',
        body: JSON.stringify(data),
      };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log('Result of the API: Put Commpany', result);
      setLoading(false);
      sendToast(result);
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  //#--> Evento para agregar emojis al mensaje
  const onEmojiClick2 = (event, emojiObject) => {
    setBodyMessage((prevInput) => prevInput + emojiObject.emoji);
  };

  const handleType = (e) => {
    setTypeMessage(e.target.value);

    if (e.target.value == 'interactive') {
      const today = new Date();
      var hours = today.getHours();
      var minutes = today.getMinutes();
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      var time = hours + ':' + minutes;
      setDate(time);
    }
  };

  const handleChange = (event) => {
    setSelectedImage((selectedImage) => {
      return '';
    });
    setSelectedVideo((selectedVideo) => {
      return '';
    });
    setSelectedDocument((selectedDocument) => {
      return '';
    });
    setNumberParams([]);
    setIsUrlDynamic('');
    setIsUrlDynamic2('');
    setListButtonsCallToAction([]);
    setListButtonsQuickReply([]);
    setTemplateSelected([]);
    setListButtonsUrlDynamic([]);
    setErrorCampaign(false);
    console.log('Template Selected: ', event);

    let template = [event];
    setTemplateSelected(template);

    //#--> Validamos que si haya una plantilla selecionada
    // if (selected[0]) {
    if (template[0]) {
      templateIdRef.current = template[0].id;
      //#--> Validamos que si tenga header la plantilla selecionada
      const filterHeader = template[0].content.filter((tem) => {
        if (tem.type === 'HEADER') return tem;
      });
      console.log('filterHeader==============>', filterHeader);
      if (filterHeader.length != 0) {
        setTemplateWhatsapp(true);
        setTemplateHeader(true);
        setContentHeader(filterHeader[0].format);
        setContentTextHeader(filterHeader[0].text);
      } else {
        setTemplateWhatsapp(false);
        setTemplateHeader(false);
        setContentHeader('');
      }

      //#--> Validamos que si tenga Body la plantilla selecionada
      const filterBody = template[0].content.filter((tem) => {
        if (tem.type === 'BODY') return tem;
      });
      const bod = filterBody[0].text;
      console.log('-----Valor del body------->', bod);
      setBody(bod);
      //#--> validamos si el contenido tiene parametros
      const params = bod.match(/{{\d+}}/g);
      const paramsForm = Object.entries(getValues())
        .filter(([key, value]) => key.startsWith('param'))
        .map(([key, value]) => key);

      if (params === null && paramsForm.length > 0) unregister(paramsForm);
      setNumberParams(params);
      console.log('-----Valor del params------->', params);
      localStorage.setItem('N_PARAMS', params);

      //#--> Validamos que si tenga botones la plantilla selecionada
      const filterButtons = template[0].content.filter((tem) => {
        if (tem.type === 'BUTTONS') return tem;
      });
      console.log('filterButtons ===>', filterButtons);

      if (filterButtons.length != 0) {
        const listButtons = filterButtons[0].buttons;
        console.log('lista de botones ===>', listButtons);

        var listButtonsCallToAction = [];
        var listButtonsQuickReply = [];
        var listButtonsUrlDynamic = [];
        for (let b = 0; b < listButtons.length; b++) {
          const element = listButtons[b];

          if (element.type == 'URL') {
            listButtonsCallToAction.push(element);

            if (element.example) {
              listButtonsUrlDynamic.push(element);
              setIsUrlDynamic(true);
            }
          } else if (element.type == 'PHONE_NUMBER') {
            listButtonsCallToAction.push(element);
          } else if (element.type == 'QUICK_REPLY') {
            listButtonsQuickReply.push(element);
          }
        }
        console.log('listButtonsCallToAction==>', listButtonsCallToAction);
        console.log('listButtonsQuickReply==>', listButtonsQuickReply);
        console.log('listButtonsUrlDynamic==>', listButtonsUrlDynamic);

        setListButtonsCallToAction(listButtonsCallToAction);
        setListButtonsQuickReply(listButtonsQuickReply);
        setListButtonsUrlDynamic(listButtonsUrlDynamic);
      }
    }
    const today = new Date();
    var hours = today.getHours();
    var minutes = today.getMinutes();
    setValue('isProgramCamp', false);
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    var time = hours + ':' + minutes;
    setDate(time);
  };

  const onParams = (e, index) => {
    const selectedValue = e.target.value;

    setNumberParams((prevParams) => {
      const updatedParams = [...prevParams];
      updatedParams[index] = selectedValue;

      const updatedBody = updatedParams.reduce((body, param, k) => {
        var field = '';
        if (param === 'email') {
          field = 'Correo usuario';
        } else if (param === 'name') {
          field = 'Nombre usuario';
        } else if (param === 'phone') {
          field = 'Teléfono usuario';
        } else if (param.includes('{{')) {
          field = param;
        } else {
          field = `${param} usuario`;
        }
        const placeholder = `{{${k + 1}}}`;
        return body.replaceAll(placeholder, field);
      }, body);

      setBody(updatedBody);
      return updatedParams;
    });
  };

  const onFile = async (e) => {
    var file = e.target.files[0];
    if (file) {
      setErrorMedia(false);
    }
    var base64 = await convertBase64(file);
    setSelectedImage(base64);
    await uploadToS3(file);
  };

  const convertBase64 = (file) => {
    return new Promise((res, rej) => {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        res(fileReader.result);
      };
      fileReader.onerror = (error) => {
        rej(error);
      };
    });
  };

  const onFileDocument = async (e) => {
    var fileDocument = e.target.files[0];
    if (fileDocument) {
      setErrorMedia(false);
    }
    setDocumentt(URL.createObjectURL(e.target.files[0]));
    var nameD = e.target.files[0].name;
    var base64 = await convertDocumentBase64(fileDocument);
    setSelectedDocument(base64);
    await uploadToS3(fileDocument);
  };

  const convertDocumentBase64 = (file) => {
    return new Promise((res, rej) => {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        res(fileReader.result);
      };
      fileReader.onerror = (error) => {
        rej(error);
      };
    });
  };

  const onFileVideo = async (e) => {
    var fileDocument = e.target.files[0];
    if (fileDocument) {
      setErrorMedia(false);
    }
    console.log('archivo cargado.....', fileDocument);
    setVideoo(URL.createObjectURL(e.target.files[0]));
    console.log('url del video: ', videoo);
    console.log('url 2.....', URL.createObjectURL(e.target.files[0]));
    var base64 = await convertVideoBase64(fileDocument);
    setSelectedVideo(base64);
    await uploadToS3(fileDocument);
  };

  const convertVideoBase64 = (file) => {
    return new Promise((res, rej) => {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        res(fileReader.result);
      };
      fileReader.onerror = (error) => {
        rej(error);
      };
    });
  };

  const getSignedUrl = async (key_name, size) => {
    try {
      key_name = encodeURIComponent(key_name);
      const url = urlAPI_1 + `getSignedURL/${key_name}/${size}`;
      const options = { method: 'GET', mode: 'cors' };
      const response = await fetchWithAuth(url, options);
      if (response.status == 200) {
        let url_signed = await response.json();
        if (url_signed.error) {
          return false;
        }
        return url_signed;
      } else {
        console.error('Error getting signed URL');
        return false;
      }
      return response;
    } catch (error) {
      console.error('Error getting signed URL:', error);
      return false;
    }
  };

  const uploadToS3 = async (file) => {
    try {
      let max_size = false;
      if (file.type.includes('audio') && file.size > 1024 * 1024 * 16) {
        max_size = true;
        sendToast({
          type: 'info',
          message:
            'El archivo supera el peso máximo permitido para audio: 16MB. Intente enviarlo como documento.',
        });
      }
      if (file.type.includes('video') && file.size > 1024 * 1024 * 16) {
        max_size = true;
        sendToast({
          type: 'info',
          message:
            'El archivo supera el peso máximo permitido para video: 16MB. Intente enviarlo como documento.',
        });
      }
      if (file.type.includes('image') && file.size > 1024 * 1024 * 5) {
        max_size = true;
        sendToast({
          type: 'info',
          message:
            'El archivo supera el peso máximo permitido para imagen: 5MB. Intente enviarlo como documento.',
        });
      }
      if (file.type.includes('document') && file.size > 1024 * 1024 * 100) {
        max_size = true;
        sendToast({
          type: 'info',
          message:
            'El archivo supera el peso máximo permitido para documentos: 100MB. Intente enviarlo como documento.',
        });
      }

      if (max_size) {
        setSizeMax(true);
        setSelectedImage((selectedImage) => {
          return '';
        });
        setSelectedVideo((selectedVideo) => {
          return '';
        });
        setSelectedDocument((selectedDocument) => {
          return '';
        });
        return false;
      } else {
        setSizeMax(false);
      }
      setLoading(true);
      const signedUrl = await getSignedUrl(file.name, file.size);
      if (signedUrl) {
        urlFile.current = await upload_s3(file, signedUrl);
        nameFile.current = file.name;
        sizeFile.current = file.size;

        const fileTypes = ['audio', 'video', 'image', 'document'];
        const type = fileTypes.find(t => file.type.includes(t));
        if (type) setFileType(type);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error uploading to s3...', error);
      return false;
    }
  };

  const getIsDark = () => {
    const dark = localStorage.getItem('THEME');
    setIsDark(dark);
  };

  const customStylesDark = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#455a64' : '#202c33',
      color: state.isSelected ? 'white' : 'white',
      '&:hover': {
        backgroundColor: '#374954',
        color: 'white',
        cursor: 'pointer',
      },
    }),
  };

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'lightblue' : '#fff',
      color: state.isSelected ? '#333' : '#333',
      '&:hover': {
        backgroundColor: 'lightgray',
        color: '#333',
        cursor: 'pointer',
      },
    }),
  };

  const getTemplates = async () => {
    try {
      const url = urlAPI_2 + 'templates';
      const options = { method: 'GET', mode: 'cors' };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      const listTemplates = result.data;
      if (result.type !== 'success') {
        setTemplates([]);
      } else {
        const isTemplates = listTemplates.filter(
          (tem) => tem.status === 'APROBADA' && tem.isActive === true
        );
        setTemplates(isTemplates);
      }
    } catch (error) {
      return null;
    }
  };

  const getCorresp = async () => {
    try {
      const url = urlAPI_2 + 'getDataEmail';
      const options = { method: 'GET', mode: 'cors' };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();
      console.log('list correspondence-------->>', result.data);
      let data = result.data;
      if (data.length) {
        data = data.filter((v) => v.field !== 'callingCode');
      }
      setCorrespondence(data);
      if (result.message === 'Tu petición no tiene cabecera de autorización') {
        sendToast({
          type: 'info',
          message:
            'Tu sesion ha caducado, verifica si alguien mas se ha conectado con tus credenciales',
        });
        navigate('/');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTemplates();
    getCorresp();
    getIsDark();
  }, []);

  return (
    <>
      {loading ? (
        <div className="content-spinner">
          <Spinner />
        </div>
      ) : null}

      <div className="m-auto container-fluid p-0">
        <div className="col-xs-9 heading">
          <div>
            <h1>Mensaje de cierre</h1>
          </div>
          <Header />
        </div>

        <div className="container-fluid mt-3 px-0 d-flex align-items-center">
          <section
            className="module-create-user myData"
            style={{
              height: 'auto',
              backgroundColor: 'transparent',
              boxShadow: 'none',
              maxHeight: messageCheck ? '85vh' : 'auto',
            }}
          >
            <div>
              <form onSubmit={handleSubmit(putCompany)}>
                <div className="sections-my-data">
                  <div className="d-flex align-items-center">
                    <h2
                      className="d-flex align-items-center"
                      style={{ fontSize: '1.4em', padding: '20px 20px 0px' }}
                    >
                      <IoMdCloseCircleOutline
                        style={{ fontSize: '25px', marginRight: '10px' }}
                      />
                      Mensaje de cierre
                    </h2>
                    <input
                      name="messageCheck"
                      id="messageCheck"
                      type="checkbox"
                      value={messageCheck}
                      className="cmn-toggle cmn-toggle-round-flat"
                      // defaultChecked={messageCheck}
                      checked={messageCheck}
                      {...register('messageCheck')}
                      onChange={(e) => {
                        setMessageCheck(e.target.checked);
                      }}
                    />
                    <label className="ml-4 mb-0" htmlFor="messageCheck"></label>
                  </div>

                  {messageCheck && (
                    <div
                      className="module-section border-top-0 scrollable-content"
                      id="product-basic"
                      style={{ height: '78%', overflow: 'auto' }}
                    >
                      <div className="row h-100">
                        <div className="col-md-12 h-100">
                          <div
                            className="row h-100 mx-auto"
                            style={
                              typeMessage == 'basic'
                                ? {
                                    display: 'block',
                                    width: '500px',
                                  }
                                : {}
                            }
                          >
                            <div
                              className={
                                typeMessage !== 'basic'
                                  ? 'col-md-6 mx-auto'
                                  : ''
                              }
                            >
                              <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable mt-3">
                                <label>Tipo de mensaje: </label>
                                <div className="su-control-group">
                                  <select
                                    name="typeMessage"
                                    id="typeMessage"
                                    className="form-control"
                                    defaultValue="basic"
                                    {...register('typeMessage', {
                                      required: {
                                        value: true,
                                        message:
                                          'El tipo de mensaje es obligatorio.',
                                      },
                                    })}
                                    onChange={handleType}
                                  >
                                    <option value="" key="0" selected disabled>
                                      Seleccione...
                                    </option>
                                    <option value="basic" key="1">
                                      Básico
                                    </option>
                                    <option value="interactive" key="2">
                                      Interactivo
                                    </option>
                                    <option value="campaign" key="3">
                                      Campaña
                                    </option>
                                  </select>
                                  {errors.typeMessage && (
                                    <Alert>
                                      * {errors.typeMessage.message}
                                    </Alert>
                                  )}
                                </div>
                              </div>

                              {typeMessage == 'basic' && (
                                <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable mt-3">
                                  <label>Mensaje: </label>
                                  <div className="su-control-group">
                                    <textarea
                                      className="form-control p-l-5"
                                      id="bodyMessage"
                                      name="bodyMessage"
                                      type="text"
                                      value={bodyMessage}
                                      {...register('bodyMessage', {
                                        required: {
                                          value: true,
                                          message: 'El mensaje es obligatorio.',
                                        },
                                        pattern: {
                                          value: /\S+/,
                                          message:
                                            'No puede ser solo espacios en blanco',
                                        },
                                      })}
                                      onChange={(e) =>
                                        setBodyMessage(e.target.value)
                                      }
                                    ></textarea>

                                    <div className="d-flex align-items-center">
                                      {closeEmojis2 && (
                                        <IoClose
                                          className="icon-cancel ml-1 mr-2 d-flex pointer"
                                          style={{
                                            fontSize: '1.7rem',
                                            alignItems: 'center',
                                          }}
                                          onClick={() => {
                                            setShowPicker2((val) => !val);
                                            setCloseEmojis2(false);
                                          }}
                                        />
                                      )}
                                      <FaRegFaceLaugh
                                        className={
                                          showPicker2
                                            ? 'icon-smile icon-chat active d-flex mt-1'
                                            : 'icon-smile icon-chat d-flex mt-1'
                                        }
                                        style={{
                                          fontSize: '25px',
                                          alignItems: 'center',
                                        }}
                                        onClick={() => {
                                          setShowPicker2((val) => !val);
                                          if (closeEmojis2) {
                                            setCloseEmojis2(false);
                                          } else {
                                            setCloseEmojis2(true);
                                          }
                                        }}
                                      />

                                      {showPicker2 && (
                                        <Picker
                                          pickerStyle={{
                                            width: '100%',
                                            left: '0px',
                                            position: 'absolute',
                                            zIndex: '999',
                                            top: '137px',
                                          }}
                                          onEmojiClick={onEmojiClick2}
                                          groupNames={{
                                            smileys_people:
                                              'Emoticones y personas',
                                            animals_nature:
                                              'Animales y naturaleza',
                                            food_drink: 'Alimentos y bebidas',
                                            travel_places: 'Viajes y lugares',
                                            activities: 'Actividades',
                                            objects: 'Objetos',
                                            symbols: 'Símbolos',
                                            flags: 'Banderas',
                                            recently_used: 'Recientes',
                                          }}
                                        />
                                      )}
                                    </div>
                                    {errors.bodyMessage && (
                                      <Alert>
                                        * {errors.bodyMessage.message}
                                      </Alert>
                                    )}
                                  </div>
                                </div>
                              )}
                              {typeMessage == 'interactive' && (
                                <>
                                  <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable mt-3">
                                    <label>Mensaje: </label>
                                    <div className="su-control-group">
                                      <textarea
                                        className="form-control p-l-5"
                                        id="bodyMessage"
                                        name="bodyMessage"
                                        type="text"
                                        value={bodyMessage}
                                        {...register('bodyMessage', {
                                          required: {
                                            value: true,
                                            message:
                                              'El mensaje es obligatorio.',
                                          },
                                          pattern: {
                                            value: /\S+/,
                                            message:
                                              'No puede ser solo espacios en blanco',
                                          },
                                        })}
                                        onChange={(e) =>
                                          setBodyMessage(e.target.value)
                                        }
                                      ></textarea>

                                      <div className="d-flex align-items-center">
                                        {closeEmojis2 && (
                                          <IoClose
                                            className="icon-cancel ml-1 mr-2 d-flex pointer"
                                            style={{
                                              fontSize: '1.7rem',
                                              alignItems: 'center',
                                            }}
                                            onClick={() => {
                                              setShowPicker2((val) => !val);
                                              setCloseEmojis2(false);
                                            }}
                                          />
                                        )}
                                        <FaRegFaceLaugh
                                          className={
                                            showPicker2
                                              ? 'icon-smile icon-chat active d-flex mt-1'
                                              : 'icon-smile icon-chat d-flex mt-1'
                                          }
                                          style={{
                                            fontSize: '25px',
                                            alignItems: 'center',
                                          }}
                                          onClick={() => {
                                            setShowPicker2((val) => !val);
                                            if (closeEmojis2) {
                                              setCloseEmojis2(false);
                                            } else {
                                              setCloseEmojis2(true);
                                            }
                                          }}
                                        />

                                        {showPicker2 && (
                                          <Picker
                                            pickerStyle={{
                                              width: '100%',
                                              left: '0px',
                                              position: 'absolute',
                                              zIndex: '999',
                                              top: '137px',
                                            }}
                                            onEmojiClick={onEmojiClick2}
                                            groupNames={{
                                              smileys_people:
                                                'Emoticones y personas',
                                              animals_nature:
                                                'Animales y naturaleza',
                                              food_drink: 'Alimentos y bebidas',
                                              travel_places: 'Viajes y lugares',
                                              activities: 'Actividades',
                                              objects: 'Objetos',
                                              symbols: 'Símbolos',
                                              flags: 'Banderas',
                                              recently_used: 'Recientes',
                                            }}
                                          />
                                        )}
                                      </div>
                                      {errors.bodyMessage && (
                                        <Alert>
                                          * {errors.bodyMessage.message}
                                        </Alert>
                                      )}
                                    </div>
                                  </div>
                                  {interactiveOptions.length > 0 &&
                                    interactiveOptions.map((option, index) => (
                                      <div
                                        key={option.id}
                                        className="su-control su-with-prefix su-with-suffix su-segmentation-disable mt-3"
                                      >
                                        <label>Opción {index + 1}: </label>
                                        <div
                                          className="su-control-group"
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <input
                                            className="form-control p-l-5"
                                            id={`label-button-${option.id}`}
                                            name={`label-button-${option.id}`}
                                            type="text"
                                            value={option.label}
                                            {...register(
                                              `label-button-${index}`,
                                              {
                                                required: {
                                                  value: true,
                                                  message:
                                                    'El mensaje es obligatorio.',
                                                },
                                                pattern: {
                                                  value: /\S+/,
                                                  message:
                                                    'No puede ser solo espacios en blanco',
                                                },
                                                maxLength: {
                                                  value:
                                                    interactiveOptions.length >
                                                    3
                                                      ? 24
                                                      : 20,
                                                  message: `Máximo ${
                                                    interactiveOptions.length >
                                                    3
                                                      ? 24
                                                      : 20
                                                  } caracteres.`,
                                                },
                                              }
                                            )}
                                            onChange={(e) => {
                                              const updatedOptions = [
                                                ...interactiveOptions,
                                              ];
                                              updatedOptions[index].label =
                                                e.target.value;
                                              setInteractiveOptions(
                                                updatedOptions
                                              );
                                            }}
                                          />
                                          <button
                                            onClick={() => {
                                              setInteractiveOptions(
                                                interactiveOptions.filter(
                                                  (_, i) => i !== index
                                                )
                                              );
                                            }}
                                            className="text-danger border-0 bg-transparent d-block pointer text-left"
                                          >
                                            <BsTrash3
                                              style={{ fontSize: '18px' }}
                                            />
                                          </button>
                                        </div>
                                        {errors[`label-button-${index}`] && (
                                          <Alert>
                                            *{' '}
                                            {
                                              errors[`label-button-${index}`]
                                                .message
                                            }
                                          </Alert>
                                        )}
                                      </div>
                                    ))}

                                  <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable mt-3">
                                    <input
                                      type="button"
                                      className="btn btn-default"
                                      style={{ width: '100%' }}
                                      value="Agregar Botón"
                                      onClick={() => {
                                        setInteractiveOptions((prev) => {
                                          if (prev.length >= 10) {
                                            return prev;
                                          }

                                          setErrorOptions(false);

                                          return [
                                            ...prev,
                                            {
                                              label: '',
                                              id:
                                                crypto.randomUUID() +
                                                '_interactive_campaign',
                                            },
                                          ];
                                        });
                                      }}
                                    />
                                  </div>
                                  {errorOptions && (
                                    <Alert>* 1 Botón o más requeridos</Alert>
                                  )}
                                </>
                              )}
                              {typeMessage == 'campaign' && (
                                <>
                                  <div
                                    style={{ marginTop: '15px' }}
                                    className="su-control su-with-prefix su-with-suffix su-segmentation-disable"
                                  >
                                    <label htmlFor="templates">
                                      Plantillas:{' '}
                                    </label>
                                    <Select
                                      styles={
                                        isDark == 'true'
                                          ? customStylesDark
                                          : customStyles
                                      }
                                      className="form-control select-template"
                                      placeholder="Selecciona una plantilla"
                                      value={templateSelected}
                                      onChange={handleChange}
                                      options={[...templates].reverse()}
                                      getOptionLabel={(option) => (
                                        <div
                                          className="option d-flex"
                                          style={{ fontSize: '15px' }}
                                        >
                                          {`${option.name} - (${option.language})`}
                                        </div>
                                      )}
                                      getOptionValue={(option) =>
                                        `${option.name} - ${option.language}`
                                      }
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                    />
                                    {errorCampaign && (
                                      <Alert>* Plantilla requerida</Alert>
                                    )}

                                    {/* CARGAR ARCHIVOS  */}
                                    {templateHeader &&
                                      templateSelected.map((template, t) => {
                                        return (
                                          <div key={t}>
                                            {contentHeader === 'IMAGE' ? (
                                              <div className="mt-3">
                                                <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable">
                                                  <label>Cargar imagen: </label>
                                                  <div className="su-control-group">
                                                    <input
                                                      type="file"
                                                      name="image"
                                                      id="inputMedia"
                                                      className="form-control"
                                                      accept="image/gif,image/jpeg,image/jpg,image/png"
                                                      // {...register("image", {
                                                      //   required: {
                                                      //     value: true,
                                                      //     message: "El medio es requerido.",
                                                      //   },
                                                      // })}
                                                      onChange={(e) =>
                                                        onFile(e)
                                                      }
                                                    />
                                                    {/* {errors.image && (<Alert>* {errors.image.message}</Alert>)} */}
                                                    {errorMedia && (
                                                      <Alert>
                                                        * El medio es requerido
                                                      </Alert>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            ) : contentHeader === 'VIDEO' ? (
                                              <div className="mt-3">
                                                <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable">
                                                  <label>Cargar video: </label>
                                                  <div className="su-control-group">
                                                    <input
                                                      type="file"
                                                      name="video"
                                                      id="inputMedia"
                                                      className="form-control"
                                                      placeholder="Add profile picture"
                                                      accept="video/*"
                                                      // {...register("video", {
                                                      //   required: {
                                                      //     value: true,
                                                      //     message: "El medio es requerido.",
                                                      //   },
                                                      // })}
                                                      onChange={(e) =>
                                                        onFileVideo(e)
                                                      }
                                                    />
                                                    {/* {errors.video && (<Alert>* {errors.video.message}</Alert>)} */}
                                                    {errorMedia && (
                                                      <Alert>
                                                        * El medio es requerido
                                                      </Alert>
                                                    )}
                                                    <div>
                                                      <ul>
                                                        <li
                                                          style={{
                                                            padding: '5px',
                                                          }}
                                                        >
                                                          <BsFillInfoCircleFill
                                                            style={{
                                                              fontSize: '17px',
                                                              marginRight:
                                                                '5px',
                                                            }}
                                                          />
                                                          El tamaño maximo
                                                          permitido es de 15MB.
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : contentHeader === 'DOCUMENT' ? (
                                              <div className="mt-3">
                                                <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable">
                                                  <label>
                                                    Cargar documento:{' '}
                                                  </label>
                                                  <div className="su-control-group">
                                                    <input
                                                      type="file"
                                                      name="document"
                                                      id="inputMedia"
                                                      className="form-control"
                                                      accept="audio/*,.pdf,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                      onChange={(e) =>
                                                        onFileDocument(e)
                                                      }
                                                    />
                                                    {errorMedia && (
                                                      <Alert>
                                                        * El medio es requerido
                                                      </Alert>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            ) : contentHeader === 'LOCATION' ? (
                                              <div className="mt-3">
                                                <div>
                                                  <label>
                                                    Datos de la ubicación:
                                                  </label>
                                                </div>
                                                <div className="d-flex">
                                                  <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable mb-0 mt-1 mr-2">
                                                    <div className="su-control-group">
                                                      <input
                                                        type="number"
                                                        name="latitud"
                                                        className="form-control"
                                                        placeholder="Latitud"
                                                        {...register(
                                                          `latitud`,
                                                          {
                                                            required: {
                                                              value: true,
                                                              message:
                                                                'La latitud es requerida.',
                                                            },
                                                            pattern: {
                                                              value: /\S+/,
                                                              message:
                                                                'No puede ser solo espacios en blanco',
                                                            },
                                                          }
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable mb-0 mt-1 mr-2">
                                                    <div className="su-control-group">
                                                      <input
                                                        type="number"
                                                        name="longitud"
                                                        className="form-control"
                                                        placeholder="Longitud"
                                                        {...register(
                                                          `longitud`,
                                                          {
                                                            required: {
                                                              value: true,
                                                              message:
                                                                'La longitud es requerida.',
                                                            },
                                                            pattern: {
                                                              value: /\S+/,
                                                              message:
                                                                'No puede ser solo espacios en blanco',
                                                            },
                                                          }
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable mb-0 mt-1 mr-2">
                                                    <div className="su-control-group">
                                                      <input
                                                        type="text"
                                                        name="name"
                                                        className="form-control"
                                                        placeholder="Nombre"
                                                        {...register(`name`, {
                                                          required: {
                                                            value: true,
                                                            message:
                                                              'El nombre es requerido.',
                                                          },
                                                          pattern: {
                                                            value: /\S+/,
                                                            message:
                                                              'No puede ser solo espacios en blanco',
                                                          },
                                                        })}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable mb-0 mt-1">
                                                    <div className="su-control-group">
                                                      <input
                                                        type="text"
                                                        name="adress"
                                                        className="form-control"
                                                        placeholder="Dirección"
                                                        {...register(`adress`, {
                                                          required: {
                                                            value: true,
                                                            message:
                                                              'La direccion es requerida.',
                                                          },
                                                          pattern: {
                                                            value: /\S+/,
                                                            message:
                                                              'No puede ser solo espacios en blanco',
                                                          },
                                                        })}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                        );
                                      })}

                                    {/* PINTAR CAMPOS PARA PARAMETROS DEL CONTENIDO*/}
                                    {numberParams
                                      ? numberParams.map((param, k) => (
                                          <div
                                            key={k}
                                            className="su-control su-with-prefix su-with-suffix su-segmentation-disable mb-0"
                                          >
                                            <div className="su-control-group d-flex align-items-center">
                                              <select
                                                name={`param${k + 1}`}
                                                id={`param${k + 1}`}
                                                className="form-control mb-1 w-100"
                                                defaultValue=""
                                                {...register(`param${k + 1}`, {
                                                  required: {
                                                    value: true,
                                                    message:
                                                      'El parametro es requerido.',
                                                  },
                                                  pattern: {
                                                    value: /\S+/,
                                                    message:
                                                      'No puede ser solo espacios en blanco',
                                                  },
                                                })}
                                                onChange={(e) => onParams(e, k)}
                                              >
                                                <option
                                                  value=""
                                                  key="99"
                                                  disabled
                                                >
                                                  {`Introducir contenido para {{${
                                                    k + 1
                                                  }}}:`}
                                                </option>
                                                {correspondence &&
                                                  correspondence.map(
                                                    (element, k) => (
                                                      <option
                                                        value={element.field}
                                                        key={k}
                                                      >
                                                        {element.fieldName}
                                                      </option>
                                                    )
                                                  )}
                                              </select>
                                            </div>
                                          </div>
                                        ))
                                      : null}

                                    {/* PINTAR CAMPO PARA PARAMETRO DE URL DINAMICA */}
                                    {listButtonsUrlDynamic &&
                                      listButtonsUrlDynamic.map((btn, b) => (
                                        <div
                                          key={b}
                                          className="su-control su-with-prefix su-with-suffix su-segmentation-disable mb-0"
                                        >
                                          <div className="su-control-group">
                                            <select
                                              name={`urlParam`}
                                              id={`urlParam`}
                                              className="form-control mb-3 w-100"
                                              {...register(`urlParam`, {
                                                required: {
                                                  value: true,
                                                  message:
                                                    'El parametro es requerido.',
                                                },
                                                pattern: {
                                                  value: /\S+/,
                                                  message:
                                                    'No puede ser solo espacios en blanco',
                                                },
                                              })}
                                            >
                                              <option
                                                value=""
                                                key="0"
                                                disabled
                                                selected
                                              >{`Valor para parametro de la url: `}</option>
                                              {correspondence &&
                                                correspondence.map(
                                                  (element) => (
                                                    <option
                                                      value={
                                                        element.fieldCorresp
                                                      }
                                                      key={element.field}
                                                    >
                                                      {element.fieldName}
                                                    </option>
                                                  )
                                                )}
                                            </select>
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                </>
                              )}
                            </div>
                            <div
                              className={
                                typeMessage !== 'basic' ? 'col-md-6' : ''
                              }
                            >
                              {/* MODULO PARA PREVISUALIZAR LA PLANTILLA SELECCIONADA */}
                              {typeMessage === 'campaign' &&
                                templateSelected &&
                                templateSelected.map((template, t) => {
                                  const contentFooter = template.content.filter(
                                    (tem) => {
                                      if (tem.type === 'FOOTER') return tem;
                                    }
                                  );
                                  return (
                                    <div
                                      id="preview-template"
                                      className="h-100 w-100 mt-3"
                                      key={t}
                                      style={{
                                        overflow: 'auto',
                                      }}
                                    >
                                      <div>
                                        <div className="ml-0">
                                          <section className="section-preview p-3">
                                            <h3>
                                              <span>Vista previa</span>
                                            </h3>
                                            <div className="section-div1 ml-2 mr-5">
                                              <div className="section-div2">
                                                <div className="section-div3">
                                                  <div className="section-div4">
                                                    <div
                                                      className={
                                                        contentHeader === 'TEXT'
                                                          ? 'header-preview headerText'
                                                          : selectedVideo
                                                          ? 'video-selected'
                                                          : 'header-preview'
                                                      }
                                                    >
                                                      {contentHeader &&
                                                        contentHeader ===
                                                          'TEXT' &&
                                                        contentTextHeader}

                                                      {contentHeader &&
                                                      contentHeader ===
                                                        'IMAGE' ? (
                                                        <>
                                                          {selectedImage ? (
                                                            <img
                                                              src={
                                                                selectedImage
                                                              }
                                                              className="w-100"
                                                              style={{
                                                                borderRadius:
                                                                  '5px',
                                                              }}
                                                            />
                                                          ) : (
                                                            <div className="medio-image custom-media"></div>
                                                          )}
                                                        </>
                                                      ) : contentHeader ===
                                                        'VIDEO' ? (
                                                        <>
                                                          {selectedVideo ? (
                                                            <ReactPlayer
                                                              url={videoo}
                                                              loop
                                                              controls
                                                              width="100%"
                                                              height="100%"
                                                            />
                                                          ) : (
                                                            <div className="medio-video custom-media"></div>
                                                          )}
                                                        </>
                                                      ) : contentHeader ===
                                                        'DOCUMENT' ? (
                                                        <>
                                                          {documentt ? (
                                                            <iframe
                                                              src={documentt}
                                                            ></iframe>
                                                          ) : (
                                                            <div className="medio-document custom-media"></div>
                                                          )}
                                                        </>
                                                      ) : contentHeader ===
                                                        'LOCATION' ? (
                                                        <>
                                                          <div className="medio-location custom-media"></div>
                                                        </>
                                                      ) : null}
                                                    </div>

                                                    {contentHeader ===
                                                      'LOCATION' && (
                                                      <div className="data-location">
                                                        <div className="location-name">
                                                          {'{{Location name}}'}
                                                        </div>
                                                        <div className="location-adress">
                                                          {'{{Adress}}'}
                                                        </div>
                                                      </div>
                                                    )}

                                                    <div className="section-div5">
                                                      <span className="span">
                                                        <span>
                                                          {/* {content && content} */}
                                                          {body && body}
                                                        </span>
                                                      </span>
                                                    </div>

                                                    {contentFooter.length >
                                                    0 ? (
                                                      <div className="content-footer">
                                                        {contentFooter[0].text}
                                                      </div>
                                                    ) : null}

                                                    <time
                                                      aria-hidden="true"
                                                      className="_6xe5"
                                                    >
                                                      {date}
                                                    </time>
                                                  </div>

                                                  {/* LISTA DE BOTONES DE LLAMADA A LA ACCIÓN */}
                                                  {listButtonsCallToAction &&
                                                    listButtonsCallToAction.map(
                                                      (btn, b) => (
                                                        <div
                                                          key={b}
                                                          className="content-botton"
                                                        >
                                                          <div>
                                                            {btn.type ==
                                                            'PHONE_NUMBER' ? (
                                                              <BsFillTelephoneFill
                                                                className="mr-1"
                                                                style={{
                                                                  fontSize:
                                                                    '1.3rem',
                                                                }}
                                                              />
                                                            ) : (
                                                              <TiExport
                                                                className="mr-1"
                                                                style={{
                                                                  fontSize:
                                                                    '1.3rem',
                                                                }}
                                                              />
                                                            )}
                                                            <span>
                                                              {btn.text}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      )
                                                    )}
                                                </div>

                                                {/* LISTA DE BOTONES DE RESPUESTA RAPIDA */}
                                                {listButtonsQuickReply &&
                                                  listButtonsQuickReply.map(
                                                    (btn, b) => (
                                                      <div
                                                        key={b}
                                                        className="content-fastAnswer"
                                                      >
                                                        <div>
                                                          <span>
                                                            {btn.text}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                              </div>
                                            </div>
                                          </section>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}

                              {/* MODULO PARA PREVISUALIZAR LA MENSAJE INTERACTIVO */}
                              {typeMessage === 'interactive' && (
                                <div
                                  id="preview-template"
                                  className="h-100 w-100 mt-3"
                                  style={{
                                    overflow: 'auto',
                                  }}
                                >
                                  <div>
                                    <div className="ml-0">
                                      <section className="section-preview p-3">
                                        <h3>
                                          <span>Vista previa</span>
                                        </h3>
                                        <div className="section-div1 ml-2 mr-5">
                                          <div className="section-div2">
                                            <div className="section-div3">
                                              <div className="section-div4">
                                                <div className="section-div5">
                                                  <span className="span">
                                                    <span>
                                                      {bodyMessage &&
                                                        bodyMessage}
                                                    </span>
                                                  </span>
                                                </div>

                                                <time
                                                  aria-hidden="true"
                                                  className="_6xe5"
                                                >
                                                  {date}
                                                </time>
                                              </div>
                                            </div>

                                            {/* LISTA DE BOTONES DE RESPUESTA RAPIDA */}
                                            {interactiveOptions &&
                                              interactiveOptions.map(
                                                (btn, b) => (
                                                  <div
                                                    key={b}
                                                    className="content-fastAnswer"
                                                  >
                                                    <div>
                                                      <span>{btn.label}</span>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                          </div>
                                        </div>
                                      </section>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <footer className="mx-0">
                    <div className="row">
                      <div className="col-sm-6"></div>
                      <div className="col-sm-6 right">
                        <input
                          className="btn btn-lg btn-info"
                          value="Actualizar"
                          type="submit"
                        />
                      </div>
                    </div>
                  </footer>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>

      <Toaster />

      {/* <ToastContainer
        position="top-center"
        autoClose={52000}
        // autoClose={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        // draggable
        theme={JSON.parse(localStorage.getItem('THEME')) ? 'dark' : 'light'}
        toastClassName="custom-toast" // Aplica estilos personalizados a cada toast individualmente
        bodyClassName="custom-toast-body"
      /> */}
    </>
  );
};

export default CloseMessage;

const Alert = styled.span`
  color: red;
  display: block;
  width: 250px;
`;
